import React, { useMemo } from 'react'
import SelectBox from '../../../components/SelectBox'

const AccountCreatePanel = ({
  mode = 'create',
  formState,
  onChange,
  onSubmit,
  onReset,
  loading = false,
  bankOptions = [],
}) => {
  const selectedBank = useMemo(() => {
    if (!formState?.bankType) return bankOptions[0] ?? {}

    if (formState.bankType?.value) {
      return (
        bankOptions.find((option) => option.value === formState.bankType.value) ??
        formState.bankType
      )
    }

    if (typeof formState.bankType === 'string') {
      return (
        bankOptions.find((option) => option.value === formState.bankType) ?? {}
      )
    }

    return formState.bankType
  }, [bankOptions, formState?.bankType])

  const handleSubmit = (event) => {
    event.preventDefault()
    onSubmit?.()
  }

  const handleReset = () => {
    onReset?.()
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="flex h-full flex-col gap-6 rounded-3xl border border-customSurface/10 bg-gradient-to-br from-customSlate via-white to-customSky px-6 py-7 shadow-accountPanel dark:from-customSurface dark:via-customSurfaceMuted dark:to-customSurfaceMuted"
    >
      <header className="space-y-2">
        <p className="inline-flex items-center gap-2 rounded-full bg-white/70 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-customAccent dark:bg-white/5">
          {mode === 'edit' ? 'Update Account' : 'Create new account'}
        </p>
        <h2 className="text-2xl font-semibold text-customInk dark:text-customHeading">
          {mode === 'edit'
            ? 'Refresh account details'
            : 'Add a new payment account'}
        </h2>
        <p className="text-sm text-customSecondaryText dark:text-customMuted">
          Store each bank account with its dedicated bank type, so reviewers can
          route new transfers without friction.
        </p>
      </header>

      <div className="grid gap-4">
        <label className="grid gap-2 text-sm font-medium text-customPrimaryText dark:text-customHeading">
          Account name
          <input
            type="text"
            value={formState.accountName}
            onChange={(event) => onChange?.('accountName', event.target.value)}
            placeholder="e.g. KBZ Primary Collections"
            className="w-full rounded-xl border border-customBorder/20 bg-white/80 px-3 py-2 text-[13px] text-customPrimaryText shadow-inner focus:border-customAccent focus:outline-none focus:ring-2 focus:ring-customAccent/30 dark:border-white/10 dark:bg-customSurfaceMuted/80 dark:text-customHeading"
            required
            autoComplete="off"
          />
        </label>

        <label className="grid gap-2 text-sm font-medium text-customPrimaryText dark:text-customHeading">
          Account number
          <input
            type="text"
            value={formState.accountNumber}
            onChange={(event) => onChange?.('accountNumber', event.target.value)}
            placeholder="e.g. 998877665544"
            className="w-full rounded-xl border border-customBorder/20 bg-white/80 px-3 py-2 text-[13px] text-customPrimaryText shadow-inner focus:border-customAccent focus:outline-none focus:ring-2 focus:ring-customAccent/30 dark:border-white/10 dark:bg-customSurfaceMuted/80 dark:text-customHeading"
            required
            autoComplete="off"
          />
        </label>

        <label className="grid gap-2 text-sm font-medium text-customPrimaryText dark:text-customHeading">
          Bank type
          <SelectBox
            selected={selectedBank}
            setSelected={(value) => onChange?.('bankType', value)}
            options={bankOptions}
          />
        </label>

        {/* <label className="grid gap-2 text-sm font-medium text-customPrimaryText dark:text-customHeading">
          Created date
          <input
            type="date"
            value={formState.createdDate}
            max={new Date().toISOString().slice(0, 10)}
            onChange={(event) => onChange?.('createdDate', event.target.value)}
            className="w-full rounded-xl border border-customBorder/20 bg-white/80 px-3 py-2 text-sm text-customPrimaryText shadow-inner focus:border-customAccent focus:outline-none focus:ring-2 focus:ring-customAccent/30 dark:border-white/10 dark:bg-customSurfaceMuted/80 dark:text-customHeading"
            required
          />
        </label> */}
      </div>

      <footer className="mt-auto flex items-center justify-between gap-3 pt-2">
        <button
          type="button"
          onClick={handleReset}
          className="rounded-xl border border-transparent bg-white/80 px-4 py-2 text-sm font-semibold text-customPrimaryText transition hover:bg-white dark:bg-customSurfaceMuted dark:text-customHeading dark:hover:bg-customSurface"
        >
          {mode === 'edit' ? 'Cancel edit' : 'Reset'}
        </button>
        <button
          type="submit"
          disabled={loading}
          className="inline-flex items-center gap-2 rounded-xl bg-customAccentBlue dark:bg-customAccent px-5 py-2 text-sm font-semibold text-white shadow-lg shadow-customAccentBlue/30 transition hover:bg-customAccentBlue/80 disabled:cursor-not-allowed disabled:opacity-70"
        >
          {loading ? 'Saving...' : mode === 'edit' ? 'Save changes' : 'Create'}
        </button>
      </footer>
    </form>
  )
}

export default AccountCreatePanel
